import Text2 from './Text2'
export default Text2
